module.exports = __webpack_public_path__ + "media/overlays/03-e438ea2a.png";